import React from 'react';

import CompaniesPage from '../components/CompaniesPage';

const Companies = () => (
  <CompaniesPage
    lang="fr"
    title="Entreprises partenaires | Full Stack open"
    seoDescription="Développement Full Stack dans des entreprises partenaires"
  />
);

export default Companies;
